const HEADSHOT_URL_PREFIX = 'https://content.mlb.com/images/headshots/current/60x60/';
const HEADSHOT_SILHOUETTE = 'https://content.mlb.com/images/headshots/current/60x60/generic.png';
const MILB_HEADSHOT_SILHOUETTE = 'https://img.mlbstatic.com/mlb-photos/image/upload/w_100/v1/people/generic/headshot/silo/current';
const HEADSHOT_URL_MILB_PREFIX = 'http://www.milb.com/images/';
import helpers from './../helpers';
import get from 'lodash-es/get';
const { i18n } = helpers;

/**
 * @function getStat
 * @description get the specified type & group of stat
 * @param {array} stats Stats returned by sportsdata api stats expand
 * @param {string} typeName The type of stat (gameLog|statsSingleSeason)
 * @param {string} groupName The group of stat (hitting|pitching)
 * @returns {Object|undefined} The stat with the type & group, or undefined if it doesn't exist
 */
function getStat(stats = [], typeName = '', groupName = '') {

    let ret = undefined;

    for (let i = 0, len = stats.length; i < len; i = i + 1) {

        let stat = stats[i];
        let { type, group } = stat;

        if (type.displayName === typeName && group.displayName === groupName) {

            ret = stat;
            break;
        }
    }

    return ret;

}

/**
 * @function getPlayerImage
 * @param player
 * @param sport
 * @returns {string}
 */
function getPlayerImage(player = {}, sport, imgContext = 'sport', league = {}) {

    if (player.id) {
        if (imgContext === 'league') {
            const leagueId = league.id;
            const context = leagueId ? `l${leagueId}` : 'milb';
            return `https://img.mlbstatic.com/mlb-photos/image/upload/d_headshot_silo_generic.png/ar_1:1,w_60,g_face,c_thumb,z_0.7/q_auto/v1/people/${player.id}/headshot/${context}/current`;
        }
        const milbPath = `https://img.mlbstatic.com/mlb-photos/image/upload/b_auto:border,c_pad,d_headshot_silo_generic.png,q_auto:best,w_100/v1/people/${player.id}/headshot/milb/current`;
        const mlbPath = `${HEADSHOT_URL_PREFIX}${player.id}.png`;
        return sport === 'milb' ? milbPath : mlbPath;

    } else {

        return (sport === 'milb' ? MILB_HEADSHOT_SILHOUETTE : HEADSHOT_SILHOUETTE);

    }

}

/**
 * @function getPlayerUrl
 * @param mlbLinker
 * @param player
 * @returns {*}
 */
function getPlayerUrl(mlbLinker = null, player = {}, sport = null) {

    if (mlbLinker && player.id) {

        return sport === 'milb' ? `https://www.milb.com/player/${player.id}` : mlbLinker.getPlayerPageLink(player);

    } else {

        return '';

    }

}

/**
 * @function getPitcherStatLine
 * @param opts
 * @param player
 * @param decision
 * @returns {string}
 */
function getPitcherStatLine(opts = {}, player = {}, decision = '', sport = null) {

    let statLine = '';
    let seasonStats = getStat(player.stats, 'statsSingleSeason', 'pitching');
    const { mode = 'responsive' } = opts;

    if (seasonStats) {

        let { stats } = seasonStats;

        if (decision === 'save') {

            statLine = `${stats.saves}`;

        } else {

            let { era } = stats;

            if ((era === undefined) || (era === '-')) {

                era = '-.--';

            }

            statLine = `${stats.wins}-${stats.losses}`;

            let hideERA = (mode === 'MIG' && !!decision && sport !== 'milb');

            if (hideERA) {

                statLine = `${statLine}`;

            } else {

                statLine = `${statLine}, ${era} ${i18n('stats_earnedrunaverage_abbrev', 'ERA')}`;

            }

        }

    }

    return statLine;

}

export default {
    HEADSHOT_SILHOUETTE,
    getPitcherStatLine,
    getPlayerImage,
    getPlayerUrl,
    getStat
};
